import React, { useEffect, useState } from "react";
import { Alert, Button, Card, DatePicker, Form, Input, InputNumber, Space, Spin, Typography, message } from "antd";
import dayjs from "dayjs";
import api from "../api/axios";
import { euro } from "../utils/tariffs";
const { Text, Paragraph } = Typography;
export default function TarifePage() {
  const [limits, setLimits] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [busy, setBusy] = useState(false);
  const [success, setSuccess] = useState(false);
  const [form] = Form.useForm();
  useEffect(() => {
    document.title = "Kapazität ändern – Smart Routing";
    api.get("/users/me/limits").then(({ data }) => {
      setLimits(data); form.setFieldsValue({ passengers: data.effectivePassengerLimit || 1 });
    }).catch(() => setError(true)).finally(() => setLoading(false));
  }, [form]);
  const submit = async values => {
    setBusy(true);
    try {
      await api.post("/tariff-request/capacity-change", { requestedPassengerLimit: values.passengers,
        billingPeriod: limits.billingPeriod || "ANNUAL", requestedEffectiveDate: values.date?.format("YYYY-MM-DD") || null, message: values.message });
      setSuccess(true); message.success("Kapazitätsänderung angefragt.");
    } catch { message.error("Die Anfrage konnte nicht gesendet werden."); }
    finally { setBusy(false); }
  };
  if (loading) return <Spin />;
  if (error) return <Alert type="error" message="Vertragsdaten konnten nicht geladen werden. Bitte Seite neu laden." />;
  const monthly = limits.billingPeriod === "MONTHLY";
  const quote = limits.pricingQuote?.pricingMode === "FLAT" ? limits.pricingQuote : null;
  const price = monthly ? quote?.monthlyPriceNet : quote?.annualPriceNet;
  return <Space direction="vertical" size="large" style={{ width: "100%", maxWidth: 900 }}>
    <h2 className="app-page-title">Kapazität ändern</h2>
    <Card title="Ihre aktuelle Vereinbarung">
      <Paragraph><Text strong>{price == null ? "Preis noch nicht vereinbart" : `${euro.format(price)} netto/${monthly ? "Monat" : "Jahr"}`}</Text></Paragraph>
      <Paragraph>{limits.usedPassengers} von {limits.effectivePassengerLimit} Fahrgastplätzen genutzt.</Paragraph>
      <Text type="secondary">Preis und Fahrgastlimit werden individuell für Ihren Account festgelegt.</Text>
    </Card>
    {success && <Alert type="success" showIcon message="Anfrage übermittelt" description="Sie erhalten ein individuelles Angebot. Ihre bisherigen Preise und Grenzen bleiben bis zur Vereinbarung bestehen." />}
    <Card title="Andere Fahrgastkapazität anfragen">
      <Form form={form} layout="vertical" onFinish={submit} disabled={success}>
        <Form.Item name="passengers" label="Gewünschte Fahrgastkapazität" rules={[{ required: true, message: "Fahrgastkapazität eingeben." }]}>
          <InputNumber min={1} max={2147483647} precision={0} style={{ width: "100%" }} />
        </Form.Item>
        <Form.Item name="date" label="Gewünschter Änderungszeitpunkt">
          <DatePicker format="DD.MM.YYYY" disabledDate={date => date && date.isBefore(dayjs().startOf("day"))} />
        </Form.Item>
        <Form.Item name="message" label="Nachricht (optional)"><Input.TextArea rows={4} /></Form.Item>
        <Button htmlType="submit" type="primary" loading={busy}>Kapazitätsänderung anfragen</Button>
      </Form>
    </Card>
  </Space>;
}
